module.exports = __webpack_public_path__ + "img/kleisma2-m@1.4873c458.webp";